<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.851"
    height="20.184"
    viewBox="0 0 20.851 20.184"
  >
    <g transform="translate(-264.658 -426.933)">
      <g>
        <path
          d="M284.688,441.265a.5.5,0,0,1-.159-.026l-11.423-3.849h-7.458a.5.5,0,0,1-.5-.5v-8.47a.5.5,0,0,1,.932-.251,9.419,9.419,0,0,0,1.835,2.262c1.207,1.263,2.7,1.233,5.034-.065a.686.686,0,0,0,.417-.525c.091-.7-.8-1.736-1.122-2.046a.5.5,0,0,1,.619-.78c.384.246,9.419,6.057,11.365,8.073,2.114,2.192.98,5.688.932,5.835A.5.5,0,0,1,284.688,441.265Zm-18.54-4.875h7.037a.506.506,0,0,1,.16.026l10.991,3.7c.2-.935.454-3.006-.827-4.336-1.33-1.377-6.4-4.784-9.231-6.652a2.078,2.078,0,0,1,.08.84,1.682,1.682,0,0,1-.922,1.268c-1.718.958-4.229,1.988-6.218-.091a10,10,0,0,1-1.069-1.127Z"
          fill="#777"
        />
      </g>
      <rect
        width="19"
        height="1"
        transform="translate(265.83 443.793)"
        fill="#777"
      />
      <path
        d="M267.178,447.117l-2.52-2.71,2.516-2.781.741.67-1.9,2.1,1.9,2.038Z"
        fill="#777"
      />
      <path
        d="M282.989,447.117l-.732-.682,1.9-2.038-1.9-2.1.741-.67,2.516,2.781Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
